import { Injectable } from '@angular/core';
import { Bar, Bars } from '../models/bar.model';
import { Pair } from '../models/pair.model';
import { ApiService } from './api.service';
import { Coordinates } from '../models/coordinates.model';

@Injectable({
  providedIn: 'root'
})
export class BarService {

  constructor(
    private apiService: ApiService
  ) { }

  // Método encargado buscar los bares que coincidan con los datos introducidos
  async findBars(query: string, coordinates?: Coordinates): Promise<Bars> {
    const url = `bars/find`;
    const queryParams: Pair[] = [{ key: 'query', value: query }];

    if (coordinates) {
      queryParams.push({ key: 'lat', value: coordinates.latitude.toString() });
      queryParams.push({ key: 'lng', value: coordinates.longitude.toString() });
    }

    return this.apiService.doGet(url, queryParams);
  }

  // Método encargado buscar un bar por su id
  async getBar(id: string): Promise<Bar> {
    const url = `bars/${id}`;
    return this.apiService.doGet(url, undefined);
  }
}
